import { render } from "./GatesDetail.vue?vue&type=template&id=54a02d60&scoped=true"
import script from "./GatesDetail.vue?vue&type=script&lang=js"
export * from "./GatesDetail.vue?vue&type=script&lang=js"

import "./GatesDetail.vue?vue&type=style&index=0&id=54a02d60&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a02d60"]])

export default __exports__